import Cookies from 'js-cookie';
import { getBaseUrl } from './baseUrl';
import { parseJSON } from './utils';

const authu = Cookies.get('authu');
const baseUrl = getBaseUrl();

const request = async (/** @type {string} */ url: string, options: any = {}, isFile: boolean = false) => {
  // Set the headers conditionally based on the content type
  const headers: any = {
    Authorization: 'Bearer ' + authu,
    ...options.headers, // Allow overriding or adding custom headers
  };

  let body: any = undefined;

  // Only set body for non-GET requests
  if (options.method !== 'GET' && options.method !== 'HEAD') {
    if (isFile) {
      // If handling file uploads, expect options.body to be FormData
      body = options.body;
    } else {
      headers['Content-Type'] = 'application/json; charset=UTF-8';
      body = options.body || {};
    }
  }

  const config: any = {
    credentials: 'include',
    ...options,
    headers,
  };

  // Only add body to config if it's defined
  if (body !== undefined) {
    config.body = body;
  }

  const response = await fetch(`${baseUrl}${url}`, config);

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return isFile ? response : parseJSON(response);
};

export default request;
